import { AlertTriangle, Plus, Trash2 } from 'lucide-react';
import React, { useContext, useState } from 'react';
import { useChatbot } from '../../../contexts/ChatbotContext';
import { useAISettings } from '../../../hooks/useAISettings';
import { AISettingsContext } from '../../../pages/settings/AISettings';

export function BotObjectives() {
  const [newObjective, setNewObjective] = useState('');
  const { chatbotPublicId } = useChatbot();
  const { objectives, addObjective, removeObjective, loading } = useAISettings();
  const { isOverLimit } = useContext(AISettingsContext);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!chatbotPublicId || !newObjective.trim() || isOverLimit) return;
    
    addObjective(newObjective, chatbotPublicId);
    setNewObjective('');
  };

  const handleRemove = (index: number) => {
    if (!chatbotPublicId) return;
    removeObjective(index, chatbotPublicId);
  };

  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
      <h3 className="text-lg font-semibold text-white mb-4">Chatbot objectives</h3>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="flex gap-2">
          <input
            type="text"
            value={newObjective}
            onChange={(e) => setNewObjective(e.target.value)}
            placeholder="Add a new goal..."
            className={`flex-1 bg-white/5 border ${isOverLimit ? 'border-red-500/50' : 'border-white/10'} rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500`}
            disabled={isOverLimit}
          />
          <button
            type="submit"
            disabled={loading || !newObjective.trim() || isOverLimit}
            className="bg-indigo-500/20 text-indigo-400 px-4 py-2 rounded-lg hover:bg-indigo-500/30 transition-colors disabled:opacity-50 flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Add
          </button>
        </div>
        
        {isOverLimit && (
          <div className="flex items-center gap-2 text-red-400 text-sm">
            <AlertTriangle className="w-4 h-4" />
            <span>Cannot add - Character limit exceeded</span>
          </div>
        )}
      </form>

      <div className="mt-6 space-y-2">
        {objectives.map((objective, index) => (
          <div
            key={index}
            className="flex items-center justify-between bg-white/5 rounded-lg p-3 group"
          >
            <span className="text-white">{objective}</span>
            <button
              onClick={() => handleRemove(index)}
              className="text-gray-400 hover:text-red-400 transition-colors opacity-0 group-hover:opacity-100"
              disabled={loading}
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}